module.exports = __webpack_public_path__ + "media/dashboard/assets/tutorials/portais-000cde4b016ade3464b6acad50f29bb2.gif";